if (!customElements.get('isolde-footer-menu')) {
  customElements.define('isolde-footer-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.sync = () => {
        this.details.open = !this.mobile.matches;
        if (this.mobile.matches) {
          this.summary.removeAttribute('tabindex');
          this.summary.removeAttribute('aria-disabled');
        } else {
          this.summary.setAttribute('tabindex', '-1');
          this.summary.setAttribute('aria-disabled', 'true');
        }
      };
      this.onClick = (event) => { if (!this.mobile.matches) event.preventDefault(); };
      this.summary.addEventListener('click', this.onClick);
      this.mobile.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.summary.removeEventListener('click', this.onClick);
      this.mobile.removeEventListener('change', this.sync);
    }
  });
}
